export const checkEmailValidation = (emailInput: string) => {
  // 이메일 유효성을 검사할 정규식
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

  // 주어진 이메일이 유효한지 여부를 반환
  return emailPattern.test(emailInput)
}
